
const introSlideFormVisible = () => {

    const sections = document.querySelectorAll(".s-intro-slide");

    sections.forEach(section => {
        const buttons = section.querySelectorAll(".s-intro-slide__form-button");
        buttons.forEach(button => {
            button.addEventListener("click", () => {
                const body = document.querySelector("body");
                const form = button.parentElement.nextElementSibling;
                section.classList.add("--s-selected");
                form.classList.add("--js-open");
                body.classList.add("--opened-modal");
            })
        });
    });
}


const introSlideFormHidden = () => {

    const sections = document.querySelectorAll(".s-intro-slide");
    sections.forEach(section => {
        const closes = section.querySelectorAll(".s-intro-slide__form");
        closes.forEach(close => {
            close.addEventListener("click", (e) => {
                const element = e.target as HTMLElement

                if (element.classList.contains("f-intro-slide__close") || element === close) {
                    const body = document.querySelector("body");
                    close.classList.remove("--js-open")
                    section.classList.remove("--s-selected");
                    body.classList.remove("--opened-modal");
                }
            })
        });
    });
}

introSlideFormVisible();
introSlideFormHidden();
